import type { HTMLAttributes } from 'react'
import { cn } from './cn'

export interface MeterProps extends Omit<HTMLAttributes<HTMLDivElement>, 'aria-label'> {
  value?: number
  full?: boolean
  /** Accessible name for the progressbar (required unless aria-label is passed). */
  label: string
}


/** Progress meter (0–100). `full` switches the fill to success-green. */
export function Meter({ value = 0, full = false, label, className = '', ...props }: MeterProps) {
  const extraLabel =
    'aria-label' in props && typeof props['aria-label'] === 'string' ? props['aria-label'].trim() : ''
  const accessibleName = label.trim() || extraLabel
  const v = Math.max(0, Math.min(100, value))
  return (
    <div
      role="progressbar"
      aria-label={accessibleName || undefined}
      aria-valuenow={v}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('h-2 rounded-pill bg-stone overflow-hidden', className)}
      {...props}
    >
      <span className={cn('block h-full rounded-pill', full ? 'bg-ok' : 'bg-vjal-500')} style={{ inlineSize: `${v}%` }} />
    </div>
  )
}